import {
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  onSnapshot,
  where,
} from "firebase/firestore";
import { firestore } from "../../services/firebase";

const SearchCustomers = (
  collectionName,
  lastDoc,
  limitNumber,
  existingData,
  setData,
  fieldToFilter,
  valueToMatch,
  fieldToFilter2,
  valueToMatch2,
  filters = null // Updated to handle viewType-based filtering
) => {
  const dataCollection = collection(firestore, collectionName);

  let firestoreQuery = query(dataCollection, orderBy("createdAt", "desc"));

  // Apply branchId and blockHouse filters
  if (fieldToFilter && valueToMatch !== undefined) {
    firestoreQuery = query(
      firestoreQuery,
      where(fieldToFilter, "==", valueToMatch)
    );
  }
  if (fieldToFilter2 && valueToMatch2 !== undefined) {
    firestoreQuery = query(
      firestoreQuery,
      where(fieldToFilter2, "==", valueToMatch2)
    );
  }

  // Apply filters based on viewType
  if (filters) {
    const { viewType, currentDate } = filters;
    if (viewType === "members") {
      firestoreQuery = query(
        firestoreQuery,
        where("membershipExpiry", ">", currentDate),
        where("isBlocked", "==", false)
      );
    } else if (viewType === "blocked") {
      firestoreQuery = query(firestoreQuery, where("isBlocked", "==", true));
    } else {
      // Regular: membershipExpiry <= currentDate or null, and not blocked
      firestoreQuery = query(
        firestoreQuery,
        where("membershipExpiry", "<=", currentDate),
        where("isBlocked", "==", false)
      );
    }
  }

  if (lastDoc) {
    firestoreQuery = query(firestoreQuery, startAfter(lastDoc.createdAt));
  }

  if (limitNumber) {
    firestoreQuery = query(firestoreQuery, limit(limitNumber));
  }

  return onSnapshot(firestoreQuery, (querySnapshot) => {
    const newData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Merge the new data with the existing data
    const mergedData = lastDoc ? [...existingData, ...newData] : newData;
    setData(mergedData);
  });
};

export default SearchCustomers;
